import { render, staticRenderFns } from "./TabletHowItWorksSection.vue?vue&type=template&id=8a84fd8c&scoped=true"
import script from "./TabletHowItWorksSection.vue?vue&type=script&lang=js"
export * from "./TabletHowItWorksSection.vue?vue&type=script&lang=js"
import style0 from "./TabletHowItWorksSection.vue?vue&type=style&index=0&id=8a84fd8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84fd8c",
  null
  
)

export default component.exports